import Vue from 'vue';
import App from './App.vue';

// eslint-disable-next-line
import styles from './scss/main.scss';

// Apollo GraphQL
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';

Vue.use(VueApollo);

const cache = new InMemoryCache();
let apiUrl = process.env.VUE_APP_API_URL;

const apolloClient = new ApolloClient({
  link: createHttpLink({ uri: apiUrl }),
  cache
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

Vue.config.productionTip = false;

// Globala komponenter. g for global
import Title from '@/components/Title';
import Button from '@/components/Button';
import MarkdownIt from '@/components/MarkdownIt';
import SiteLoader from '@/components/SiteLoader';
Vue.component('g-title', Title);
Vue.component('g-button', Button);
Vue.component('g-markdown', MarkdownIt);
Vue.component('g-site-loader', SiteLoader);

// Check view
import checkView from 'vue-check-view';
Vue.use(checkView);

// Scroll to
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo);

// Simple Markdown
import VueSimpleMarkdown from 'vue-simple-markdown';
Vue.use(VueSimpleMarkdown);

// Modal
import VModal from 'vue-js-modal';
Vue.use(VModal);

// Router
import VueRouter from 'vue-router';
import createRouter from './services/router';

Vue.use(VueRouter);

let routerState = {
  previous: null
};

let router = createRouter({
  routerState: routerState
});

import VueMatomo from 'vue-matomo';
Vue.use(VueMatomo, {
  router: router,
  siteId: 4,
  host: 'https://analytics.dittecpat.se/'
});

new Vue({
  el: '#app',
  router: router,
  apolloProvider,
  render: createEle => createEle(App)
}).$mount('#app');
